module.exports = __webpack_public_path__ + "static/media/rectangle-view-off.67133a25.svg";